import * as React from 'react';

import {EntityListSidebar} from './entity-list-sidebar';
import type {Props as EntityListSidebarProps} from './entity-list-sidebar';

import styles from './entity-list-sidebar-wrapper.module.css';

type Props = EntityListSidebarProps;

export function EntityListSidebarWrapper(props: Props) {
    return (
        <div className={styles.container}>
            <EntityListSidebar {...props} />
        </div>
    );
}
